<template>
    <div>
        <div v-if="expiredPersonalCards.length > 0">
            <b-notification aria-close-label="Close notification" type="is-warning is-light" class="mb-4">
                <p v-if="expiredPersonalCards.length === 1">
                    {{ expiredPersonalCards[0].displayName }} has expired. To continue using it, please
                    <a href="#" class="has-text-weight-bold" @click="openUpdateModal(expiredPersonalCards[0])">
                        update</a> the card expiration date.
                </p>
                <div v-else>
                    <p>To continue using these cards, please update their expiration dates:</p>
                    <ul>
                        <li v-for="card in expiredPersonalCards" :key="card.id" class="mt-2">
                            {{ card.displayName }} <a class="has-text-right has-text-weight-bold ml-2"
                                @click="openUpdateModal(card)">Update</a>
                        </li>
                    </ul>
                </div>
            </b-notification>
        </div>

        <div v-if="expiredGhostCards.length > 0">
            <ExpiredGhostCardNotification :payments="payments" type="is-danger is-light" />
        </div>


    </div>

</template>

<script>
import UpdateCardModal from "../CreditCardEntry/UpdateCardModal.vue";
import ExpiredGhostCardNotification from "../User/ExpiredGhostCardNotification.vue";

export default {
    name: "PaymentMethodNotifications",
    props: {
        payments: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    components: {

        ExpiredGhostCardNotification
    },
    data() {
        return {
            isModalActive: false,
            selectedCard: null,
        };
    },
    computed: {
        // Compute the list of expired cards
        expiredPersonalCards() {
            return this.payments.filter(
                (payment) =>
                    !payment.validExpiration &&
                    payment.recordType !== "Corporate Ghost Card"
            );
        },
        expiredGhostCards() {
            return this.payments.filter(
                (payment) =>
                    !payment.validExpiration &&
                    payment.recordType === "Corporate Ghost Card"
            );
        },

    },
    methods: {
        // Open the modal and set the selected card
        openUpdateModal(card) {
            this.selectedCard = card;
            //this.isModalActive = true;

            this.$buefy.modal.open({
                parent: this,
                component: UpdateCardModal,
                hasModalCard: true,
                customClass: "",
                trapFocus: true,
                props: {
                    card: card
                }
            });
        },
        openUpdateCardModal(card) {

            this.$buefy.modal.open({
                parent: this,
                component: UpdateCardModal,
                hasModalCard: true,
                customClass: "",
                trapFocus: true,
                props: {
                    card: card
                }
            });
        },

    },
};
</script>

<style scoped>
.is-warning.is-light {
    background-color: #fff0cc;
    color: #422e00;
}

.notification a:not(.button):not(.dropdown-item) {
    text-decoration: underline !important;
}
</style>